"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("src/context/context");
const MediaFileIcon_1 = tslib_1.__importDefault(require("../../../../../components/files/MediaFileIcon"));
const InvoiceFiles = (props) => {
    const link = props.file && props.file.link;
    const { toast } = (0, context_1.useToastContext)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: link ?
            (0, jsx_runtime_1.jsx)("div", { className: 'd-flex ', style: { minHeight: 500 }, children: (0, jsx_runtime_1.jsx)("iframe", { src: link, style: { height: 500, width: '100%' }, frameBorder: '0' }, link) })
            :
                (0, jsx_runtime_1.jsxs)("div", { className: 'file position-relative ml-4', style: { width: 'fit-content' }, children: [(0, jsx_runtime_1.jsxs)("a", { rel: 'noopener noreferrer', className: 'file-name', children: [(0, jsx_runtime_1.jsx)(MediaFileIcon_1.default, { extension: props.file.extension }), (0, jsx_runtime_1.jsx)("span", { style: { cursor: 'not-allowed' }, children: props.file?.originalName })] }), (0, jsx_runtime_1.jsx)("i", { className: `fas text-primary mr-${props.loadingFileIds.includes(props.file.id) ? '7 spinner' : '3 fa-file-download pointer'}`, onClick: async () => {
                                const res = await props.downloadFile(props.file.id);
                                if (res.errors !== null)
                                    res.errors.forEach(el => toast.danger(el.message));
                            } })] }) }));
};
exports.default = InvoiceFiles;
